import { broadcastChatUsernameChange } from '@core/livestream/chatUsernameRegistry'
import { liveStreamActionsSelector } from '@core/livestream/model'
import { getGlobalStore } from '@core/store'

import type { IFwnChat } from './types'

export const chatApi: IFwnChat['chat'] = {
  /**
   * Sets the chat display name for the current viewer. Can be called at any
   * point during the widget lifecycle without requiring a rerender.
   *
   * Updates the global store immediately and, if a livestream WebSocket
   * connection is active, sends `update_username` to the server.
   */
  setUsername(name: string) {
    const { usernameHydratedSet } = liveStreamActionsSelector(
      getGlobalStore().getState(),
    )
    usernameHydratedSet(name)
    broadcastChatUsernameChange(name)
  },
}
